import React from 'react'
import { Collapse, Typography } from 'antd';

const { Text } = Typography
const { Panel } = Collapse;


const PlanDetail = ({ planTitle, planText, planQuestion }) => {


    // function callback(key) {
    //     console.log(key);
    // }

    const { memberShipPlan } = JSON.parse(localStorage.getItem('userInfo'));

    const renderSubQuestionOption = (data) => {
        return data.subQuestion.selected && data.subQuestion.selected.map(Item => {
            const questionOptionSub = data.subQuestion.questionOptionImage[Item];
            return <div className="gx-mb-1 gx-mt-0">
                <p className=" gx-mb-0 gx-mt-0" >{questionOptionSub.optionLabel}</p>
                {(questionOptionSub.decisionTree !== "" || questionOptionSub.decisionTree !== "<p><br></p>") && <div style={{
                    fontSize: 15
                }} dangerouslySetInnerHTML={{ __html: questionOptionSub.decisionTree }}></div>}
            </div>
        })
    }
    const renderSubQuestion = (data) => {
        if (data.furtherDetail) {
            if (data.subQuestion && data.subQuestion.questionType === "CheckBox") {
                return <div className="gx-ml-2"><h2 className="gx-blue-font gx-mt-2" style={{
                    fontSize: 16
                }}>{data.optionLabel}</h2>
                    {renderSubQuestionOption(data)}
                </div>
            }
        }
    }

    const renderPlaneDetail = (questionOptions, selectedOptions) => {

        return selectedOptions && selectedOptions.map(Item => {
            const selectedQuestionOptions = questionOptions[parseInt(Item)];
            return <div className="gx-mb-3 gx-mt-2">
                <h2 className="gx-mb-2" style={{
                    fontSize: 16
                }}>{selectedQuestionOptions.optionLabel}</h2>
                <div style={{
                    fontSize: 15
                }} dangerouslySetInnerHTML={{ __html: selectedQuestionOptions.decisionTree }}></div>

                {renderSubQuestion(selectedQuestionOptions)}
            </div>
        })
    }

    const renderPlanQuestion = () => {
        if (planQuestion && planQuestion.length) {
            return planQuestion.map((Item, index) => {
                console.log("========== Item ========= ", Item.questionLabel, Item);

                if (Item.allowFreeUserToSee || memberShipPlan !== "free") {
                    if (Item.questionType === "TextArea") {
                        const selectedOptions = Item.selected;
                        return <Collapse defaultActiveKey="0" bordered={false}>
                            <Panel header={<h6 className="gx-blue-font">{Item.questionLabel}</h6>} key={index}>
                                <p>{selectedOptions[0]}</p>
                            </Panel>
                        </Collapse>
                    } else {
                        const questionsData = Item.questionOption ? Item.questionOption : Item.questionOptionImage;
                        const selectedOptions = Item.selected;
                        return <Collapse defaultActiveKey="0" bordered={false}>
                            <Panel header={<h6 className="gx-blue-font">{Item.questionLabel}</h6>} key={index}>
                                {questionsData ? renderPlaneDetail(questionsData, selectedOptions) : ""}
                            </Panel>
                        </Collapse>
                    }
                } else {
                    return <Collapse defaultActiveKey="0" bordered={false}>
                        <Panel header={<h6 className="gx-blue-font">{Item.questionLabel}</h6>} key={index}>
                            <Text mark>You are not allow see. update your plan for use this feature</Text>
                        </Panel>
                    </Collapse>
                }



            })
        }
    }


    return (
        <div className="custom-accordian">
            <Collapse defaultActiveKey="1" bordered={false}>

                <Panel header={<h5 className="gx-blue-font">{planTitle}</h5>} key="1">
                    <div className="gx-my-3" dangerouslySetInnerHTML={{ __html: planText }}></div>
                    {renderPlanQuestion()}
                </Panel>
            </Collapse>
        </div>

    )
}

export default PlanDetail
